import { Component } from '@angular/core';
import { OAuthService } from 'src/app/modules/auth/services/oauth.service';

@Component({
  selector: 'app-session-expired-page',
  templateUrl: './session-expired-page.component.html',
  styleUrls: ['./session-expired-page.component.scss']
})
export class SessionExpiredPageComponent {
  constructor(public oauthService: OAuthService) {}
}
